import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import * as React from 'react';
import { VariableSizeList } from 'react-window';
import { Row } from './utils';

var VariableSizeTree =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(VariableSizeTree, _React$PureComponent);

  VariableSizeTree.getDerivedStateFromProps = function getDerivedStateFromProps(_ref) {
    var component = _ref.children,
        treeData = _ref.itemData;
    return {
      component: component,
      treeData: treeData
    };
  };

  function VariableSizeTree(props, context) {
    var _this;

    _this = _React$PureComponent.call(this, props, context) || this;
    _this.list = React.createRef();
    _this.getItemSize = _this.getItemSize.bind(_assertThisInitialized(_this));
    var initialState = {
      component: props.children,
      order: [],
      records: {}
    };
    _this.state = _extends({}, initialState, {}, _this.computeTree({
      refreshNodes: true
    }, props, initialState));
    return _this;
  }

  var _proto = VariableSizeTree.prototype;

  _proto.recomputeTree = function recomputeTree(options) {
    try {
      var _this3 = this;

      return Promise.resolve(new Promise(function (resolve) {
        _this3.setState(function (prevState) {
          return _this3.computeTree(options, _this3.props, prevState);
        }, function () {
          if (options == null ? void 0 : options.useDefaultHeight) {
            var _this3$list$current;

            (_this3$list$current = _this3.list.current) == null ? void 0 : _this3$list$current.resetAfterIndex(0, true);
          }

          resolve();
        });
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.resetAfterId = function resetAfterId(id, shouldForceUpdate) {
    var _this$list$current;

    if (shouldForceUpdate === void 0) {
      shouldForceUpdate = false;
    }

    (_this$list$current = this.list.current) == null ? void 0 : _this$list$current.resetAfterIndex(this.state.order.indexOf(id), shouldForceUpdate);
  };

  _proto.scrollTo = function scrollTo(scrollOffset) {
    var _this$list$current2;

    (_this$list$current2 = this.list.current) == null ? void 0 : _this$list$current2.scrollTo(scrollOffset);
  };

  _proto.scrollToItem = function scrollToItem(id, align) {
    var _this$list$current3;

    (_this$list$current3 = this.list.current) == null ? void 0 : _this$list$current3.scrollToItem(this.state.order.indexOf(id) || 0, align);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        itemSize = _this$props.itemSize,
        rowComponent = _this$props.rowComponent,
        treeWalker = _this$props.treeWalker,
        rest = _objectWithoutPropertiesLoose(_this$props, ["children", "itemSize", "rowComponent", "treeWalker"]);

    return React.createElement(VariableSizeList, Object.assign({}, rest, {
      itemData: this.state,
      itemCount: this.state.order.length // tslint:disable-next-line:no-unbound-method
      ,
      itemSize: itemSize || this.getItemSize,
      ref: this.list
    }), rowComponent);
  };

  _proto.computeTree = function computeTree(_temp, _ref2, _ref3) {
    var _ref4 = _temp === void 0 ? {} : _temp,
        _ref4$refreshNodes = _ref4.refreshNodes,
        refreshNodes = _ref4$refreshNodes === void 0 ? false : _ref4$refreshNodes,
        _ref4$useDefaultHeigh = _ref4.useDefaultHeight,
        useDefaultHeight = _ref4$useDefaultHeigh === void 0 ? false : _ref4$useDefaultHeigh,
        _ref4$useDefaultOpenn = _ref4.useDefaultOpenness,
        useDefaultOpenness = _ref4$useDefaultOpenn === void 0 ? false : _ref4$useDefaultOpenn;

    var treeWalker = _ref2.treeWalker;
    var prevRecords = _ref3.records;
    var order = [];

    var records = _extends({}, prevRecords);

    var iter = treeWalker(refreshNodes);

    if (useDefaultHeight || useDefaultOpenness) {
      for (var id in records) {
        if (useDefaultHeight) {
          records[id].height = records[id].data.defaultHeight;
        }

        if (useDefaultOpenness) {
          records[id].isOpen = records[id].data.isOpenByDefault;
        }
      }
    }

    var isPreviousOpened = false;

    while (true) {
      var _iter$next = iter.next(isPreviousOpened),
          done = _iter$next.done,
          value = _iter$next.value;

      if (done || !value) {
        break;
      }

      var _id = void 0;

      if (typeof value === 'string' || typeof value === 'symbol') {
        _id = value;

        if (useDefaultOpenness) {
          records[_id].isOpen = records[_id].data.isOpenByDefault;
        }

        if (useDefaultHeight) {
          records[_id].height = records[_id].data.defaultHeight;
        }
      } else {
        _id = value.id;
        var defaultHeight = value.defaultHeight,
            isOpenByDefault = value.isOpenByDefault;
        var record = records[_id];

        if (!record) {
          records[_id] = this.createNodeRecord(value);
        } else {
          record.data = value;

          if (useDefaultOpenness) {
            record.isOpen = isOpenByDefault;
          }

          if (useDefaultHeight) {
            record.height = defaultHeight;
          }
        }
      }

      order.push(_id);
      isPreviousOpened = records[_id].isOpen;
    }

    return {
      order: order,
      records: records
    };
  };

  _proto.createNodeRecord = function createNodeRecord(data) {
    var _this5 = this;

    var _this4 = this;

    var record = {
      data: data,
      height: data.defaultHeight,
      isOpen: data.isOpenByDefault,
      resize: function resize(height, shouldForceUpdate) {
        record.height = height;

        _this4.resetAfterId(record.data.id, shouldForceUpdate);
      },
      toggle: function () {
        try {
          record.isOpen = !record.isOpen;
          return Promise.resolve(_this5.recomputeTree({
            refreshNodes: record.isOpen,
            useDefaultHeight: true
          })).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }
    };
    return record;
  };

  _proto.getItemSize = function getItemSize(index) {
    var _this$state = this.state,
        order = _this$state.order,
        records = _this$state.records;
    return records[order[index]].height;
  };

  return VariableSizeTree;
}(React.PureComponent);

VariableSizeTree.defaultProps = {
  rowComponent: Row
};
export { VariableSizeTree as default };